export default __webpack_public_path__ + "static/media/9.f4334c20.jpeg";